import { I1091Form, IFormBasicInfo } from 'legacy/lut/features/partner360/basicInfo'

import { mapNotApplicableNullable } from './mapNotApplicableNullable'

export const mapFormBasicInfoTo1091 = (data: IFormBasicInfo): Partial<I1091Form> => {
  const result = {} as Partial<Omit<I1091Form, 'EntryId' | 'PartnerId' | 'FYear' | 'ProgramType'>>

  result.BranchesNotApplicable = mapNotApplicableNullable(data.branchesIsApplicable)
  result.BranchesCount = data.branchesCount
  result.BranchesLocations = data.branchesLocations

  // Distributor
  result.WarehouseNotApplicable = mapNotApplicableNullable(data.warehouseIsApplicable)
  result.WarehouseLocations = data.warehouseLocations
  result.WarehouseCount = data.warehouseCount
  result.TotalSales = data.totalSales
  result.HPDedicatedSales = data.hpDedicatedSales
  result.EmployersCount = data.employersCount
  result.Exhibits = data.exhibits

  // Reseller
  result.ShowroomNotApplicable = mapNotApplicableNullable(data.showroomsIsApplicable)
  result.ShowroomsCount = data.showroomsCount
  result.ShowroomsLocations = data.showroomsLocations
  result.SalesCount = data.salesCount
  result.ServiceCount = data.serviceCount
  result.DemoUnits = data.demoUnits

  // Retiler
  result.OperationProfit = data.operationProfit
  result.OperationProfitYoY = data.operationProfitYoY
  result.Ticker = data.ticker
  result.GrowthStrategy = data.growthStrategy
  result.StoresTotal = data.storesTotal
  result.StoresPSHW = data.storesPSHW
  result.StoresPRHW = data.storesPRHW

  // Other
  result.EmployersCount = data.employersCount
  result.DemoUnits = data.demoUnits
  result.Turnover = data.turnover
  result.PPSShare = data.ppsShare
  result.MPSAuditRequirements = data.isMPSAuditRequirements ? 1 : 0
  result.Summary = data.summary
  result.Achievement = data.achievement

  for (const key in result) {
    if (result[key] === undefined) {
      delete result[key]
    }
  }

  return result
}
